import {
  getMaxQuantity,
  getMinimumProductQuantity,
} from '@monofront/business/utils';
import { useProduct } from '../ProductCard';
import ButtonAddToCart from '../../ButtonAddToCart';
import { IButtonAddToCartProps } from '../../ButtonAddToCart/ButtonAddToCart';
import HorizontalButtonAddToCart from '../../ButtonAddToCart/HorizontalButtonAddToCart/HorizontalButtonAddToCart';
import { useTranslations } from 'use-intl';

export const ProductAddToCart: React.FC<Omit<IButtonAddToCartProps, 'max'>> = (
  props,
) => {
  const product = useProduct();

  if (!product) {
    return null;
  }

  const maxQuantity = getMaxQuantity(product);
  const minimumProductQuantity = getMinimumProductQuantity(product.tags) || 1;

  return (
    <div className="tw-align-self-center addToCart tw-relative tw-inline-block tw-h-[44px] tw-w-11 tw-justify-self-end tw-grid-area-[addToCart]">
      <div className="tw-absolute tw-bottom-0 tw-right-0">
        <ButtonAddToCart
          {...props}
          max={maxQuantity}
          minimumProductQuantity={minimumProductQuantity}
        />
      </div>
    </div>
  );
};

export const HorizontalSearchProductAddToCart: React.FC<
  Omit<IButtonAddToCartProps, 'max'>
> = (props) => {
  const product = useProduct();

  if (!product) {
    return null;
  }

  const maxQuantity = getMaxQuantity(product);
  const minimumProductQuantity = getMinimumProductQuantity(product.tags) || 1;

  return (
    <div className="tw-align-self-center addToCart tw-relative tw-inline-block tw-h-11 tw-w-11 tw-justify-self-end tw-grid-area-[addToCart]">
      <div className="tw-absolute tw-bottom-0 tw-right-0">
        <ButtonAddToCart
          {...props}
          max={maxQuantity}
          minimumProductQuantity={minimumProductQuantity}
        />
      </div>
    </div>
  );
};

export const HorizontalProductAddToCart: React.FC<
  Omit<IButtonAddToCartProps, 'max'>
> = (props) => {
  const product = useProduct();
  const tCart = useTranslations('Cart');

  if (!product) {
    return null;
  }

  const maxQuantity = getMaxQuantity(product);
  const minimumProductQuantity = getMinimumProductQuantity(product.tags);

  return (
    <div
      className={`addToCart tw-relative tw-inline-block ${
        minimumProductQuantity !== 1 ? 'tw-h-16' : 'tw-h-11'
      } tw-w-36 tw-self-center tw-justify-self-end tw-grid-area-[addToCart]`}
    >
      <div className="tw-absolute tw-bottom-0 tw-right-0 tw-flex tw-flex-col tw-items-end">
        <HorizontalButtonAddToCart
          {...props}
          max={maxQuantity}
          minimumProductQuantity={minimumProductQuantity}
        />
        {minimumProductQuantity > 1 && props.quantity > 0 && (
          <p className="tw-lf-caption-regular tw-pt-[2px] tw-text-center tw-text-black-700">
            {tCart('minimumProductAmount', {
              minimumQuantity: minimumProductQuantity,
            })}
          </p>
        )}
      </div>
    </div>
  );
};

export const CartHorizontalProductAddToCart: React.FC<
  Omit<IButtonAddToCartProps, 'max'>
> = (props) => {
  const product = useProduct();
  const tCart = useTranslations('Cart');

  if (!product) {
    return null;
  }

  const maxQuantity = getMaxQuantity(product);
  const minimumProductQuantity = getMinimumProductQuantity(product.tags);

  return (
    <div
      className={`addToCart tw-relative tw-inline-block ${
        minimumProductQuantity !== 1 ? 'tw-h-16' : 'tw-h-11'
      } tw-w-36 tw-self-center tw-justify-self-end tw-grid-area-[addToCart]`}
    >
      <div className="tw-absolute tw-bottom-0 tw-right-0 tw-flex tw-w-[132px] tw-flex-col tw-items-center">
        <HorizontalButtonAddToCart
          {...props}
          max={maxQuantity}
          minimumProductQuantity={minimumProductQuantity}
        />
        {minimumProductQuantity > 1 && props.quantity > 0 && (
          <p className="tw-lf-caption-regular tw-pt-[2px] tw-text-center tw-text-black-700">
            {tCart('minimumProductAmount', {
              minimumQuantity: minimumProductQuantity,
            })}
          </p>
        )}
      </div>
    </div>
  );
};
